import React from 'react';
import { Search } from 'lucide-react';

type Props = { onClick: () => void };

export const TopbarSearchButton: React.FC<Props> = ({ onClick }) => (
  <button 
    type="button"
    onClick={onClick}
    className="p-2 text-gray-400 hover:text-brand-600 hover:bg-gray-100 rounded-full transition-colors flex items-center gap-2"
    title="Глобальный поиск"
    aria-label="Глобальный поиск"
  >
    <Search className="w-5 h-5" />
  </button>
);
